(function () {
  const boxes = new Set();

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function updateBox(box) {
    const endTime = Number(box.dataset.mvEndTime);

    if (!endTime || Number.isNaN(endTime)) return;

    const remaining = Math.max(0, endTime - Date.now());
    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const daysElement = box.querySelector('[data-mv-days]');
    const hoursElement = box.querySelector('[data-mv-hours]');
    const minutesElement = box.querySelector('[data-mv-minutes]');
    const secondsElement = box.querySelector('[data-mv-seconds]');

    if (daysElement) daysElement.textContent = pad(days);
    if (hoursElement) hoursElement.textContent = pad(hours);
    if (minutesElement) minutesElement.textContent = pad(minutes);
    if (secondsElement) secondsElement.textContent = pad(seconds);
  }

  function initBox(box) {
    if (box.dataset.mvSaleInitialized === 'true') return;

    const endAt = box.getAttribute('data-end-at');
    const endTime = endAt ? Date.parse(endAt) : NaN;

    if (!endTime || Number.isNaN(endTime)) {
      return;
    }

    box.dataset.mvEndTime = String(endTime);
    box.dataset.mvSaleInitialized = 'true';
    boxes.add(box);
    updateBox(box);
  }

  function init(root) {
    root.querySelectorAll('.mv-sale-deal').forEach(initBox);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  window.setInterval(function () {
    boxes.forEach(updateBox);
  }, 1000);
})();
